import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { OrderService } from 'src/app/shared/services/Order/order.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-loading-processing-order',
  templateUrl: './loading-processing-order.component.html',
  styleUrl: './loading-processing-order.component.css'
})
export class LoadingProcessingOrderComponent implements OnInit, AfterViewInit, OnDestroy{
  @Input() startComponent: boolean = false;
  private currentPhraseIndex = 0;
  private nameCompany: string = '';
  private subscription!: Subscription;


  phrases: string[] = [
    'Enviando pedido para o estabelecimento.',
    'Estamos preparando tudo para você.',
    'Seu pedido está em nossas mãos agora.',
  ];
  textExibing: string = 'Enviando pedido para o estabelecimento'
  currentImage: string = 'assets/logo/Gif/animation-logo-pulse.gif';
  
  currentIndex: number = 0;
  intervalSubscription: Subscription | undefined;
  responseOrder: any = {sucess: false, error: false};
  carregado: boolean = false;
  company!: Company;
  typeOrder: number = 0;
  counter: number = 10;
  intervalCounter: any;

  constructor(
    private elementRef: ElementRef,
    private connection: ConnectionService,
    private renderer: Renderer2,
    private orderService: OrderService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ){}

  ngOnInit(): void {
    this.connection.nameCompany$.subscribe((newNameCompany) => {
      this.nameCompany = newNameCompany
    })

    this.route.params.subscribe(params => {
      this.typeOrder = params['type'];
    })

    this.subscription = this.orderService.responseOrder$.subscribe((data) =>{
      this.responseOrder = data;
      console.log(this.responseOrder)
      if(this.responseOrder.sucess == true){

        if(this.responseOrder.local == true){ //R
          this.orderService.finishedOrderLocal(true);
        }
        else if(this.responseOrder.order.cashback == 0){ //Só redireciona automaticamente se não tiver cashback no pedido!
          this.orderService.finishedOrderUser(true);
        }
        else{
          this.startCounter();
        }
      }
      else if(this.responseOrder.error == true){

        if(this.responseOrder.local == true){
          this.orderService.finishedOrderLocal(false);
        }

      }
    })

    this.connection.company$.subscribe((data) =>{
      if(data){
        this.company = data;
      }
    })

    if(this.typeOrder == 2){
      this.phrases = [
        'Estamos preparando tudo para você.',
        'Aguardando a confirmação do pedido.',
        'Enviando seu pedido.',
      ];
    }

    this.disablePullToRefresh()

    this.getNextPhrase();

    setInterval(() => this.getNextPhrase(), 3000);

    this.disableScroll()

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.carregado = true;
    }, 500);
  }

  ngOnDestroy(): void {
    this.enableScroll();
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  startCounter(){
    this.intervalCounter = setInterval(() => {
      if(this.counter > 1){
        this.counter--;
      }
      else{
        this.goToOrders();
      }
    }, 1000);
  }

  //Função responsavel por travar de o scroll para que a tela não seja recarregada no menu
  disablePullToRefresh() {
    const element = this.elementRef.nativeElement;
    let isAtTop = true;

    // Adiciona um ouvinte para o evento de scroll
    this.renderer.listen(window, 'scroll', () => {
      // Verifica se a página está no topo
      isAtTop = window.scrollY === 0;
    });

    this.renderer.listen(element, 'touchstart', (event) => {
      // Registra a posição inicial do toque
      const startY = event.touches[0].clientY;

      // Adiciona um ouvinte para o evento de movimento de toque
      const touchMoveListener = this.renderer.listen(element, 'touchmove', (moveEvent) => {
        // Calcula a diferença entre a posição inicial e a posição atual
        const deltaY = moveEvent.touches[0].clientY - startY;

        // Se a diferença for positiva (movimento para baixo) e a página estiver no topo, previne o comportamento padrão
        if (deltaY > 0 && isAtTop) {
          moveEvent.preventDefault();
        }
      });

      // Adiciona um ouvinte para o evento de término de toque
      const touchEndListener = this.renderer.listen(element, 'touchend', () => {
        // Remove os ouvintes após o término do toque
        touchMoveListener();
        touchEndListener();
      });
    });
  }

  //Desabilita o scroll da pagina
  disableScroll(){
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
  }

  //Abilita o scroll da pagina
  enableScroll(){
    this.renderer.removeStyle(this.document.body, 'overflow');
  }

  //Resgata e retorna a próxima frase.
  getNextPhrase() {
    this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
    this.textExibing = this.phrases[this.currentPhraseIndex];
  }

  //Quando der falha na integração na mesa, redireciona para o menu
  redirect(){
    this.router.navigate([`${this.nameCompany}/P`]);
    setTimeout(() => {
      this.orderService.responseOrderSubject.next({sucess: false, error: false, local: false}) 
    }, 2000);

  }

  goToOrders(){
    clearInterval(this.intervalCounter);
    this.location.replaceState(`${this.nameCompany}/pedidos`);
    this.router.navigate([this.nameCompany, 'order-details', this.responseOrder.order.id_order]);
    setTimeout(() => {
      this.orderService.responseOrderSubject.next({sucess: false, error: false, local: false});
    }, 2000);
  }
}
